import { SalesOrder_PaymentType } from '@proto/api/orders/resources';
import { AddressType } from '@helper/address-type';
import { Recipient_Type } from '@proto/api/common/common';
import { Router } from '@angular/router';

import { RouteHelper } from '@helper/route-paths';

export class Payments {
  // query params 一律都小寫，方便判斷.
  static LINE_PAY_PARAMETER = 'linepayurl';
  static CREDIT_CARD_PARAMETER = 'meta';
  static APP_PARAMETER = 'app';
  static CREDIT_CARD_CALLBACK_DATA_PARAMETER = 'data';
  static CREDIT_CARD_CALLBACK_MACD_PARAMETER = 'macd';

  static payTypeToRecipientType(paymentType?: SalesOrder_PaymentType): Recipient_Type {
    switch (paymentType) {
      case SalesOrder_PaymentType.PAYMENT_TYPE_SEVEN_ELEVEN:
      case SalesOrder_PaymentType.PAYMENT_TYPE_FAMILY_MART: {
        return Recipient_Type.TYPE_PICKUP_STORE;
      }
      case SalesOrder_PaymentType.PAYMENT_TYPE_CASH_ON_DELIVERY:
      case SalesOrder_PaymentType.PAYMENT_TYPE_CREDIT_CARD:
      case SalesOrder_PaymentType.PAYMENT_TYPE_CREDIT_CARD_CTBC:
      case SalesOrder_PaymentType.PAYMENT_TYPE_LINE_PAY:
      case SalesOrder_PaymentType.PAYMENT_TYPE_APPLE_PAY: {
        return Recipient_Type.TYPE_TW_DELIVERY;
      }
      case SalesOrder_PaymentType.PAYMENT_TYPE_OVERSEA:
      case SalesOrder_PaymentType.PAYMENT_TYPE_OVERSEA_CTBC: {
        return Recipient_Type.TYPE_OVERSEA;
      }
      default: {
        return Recipient_Type.TYPE_UNSPECIFIED;
      }
    }
  }

  static payTypeToAddressType(paymentType?: SalesOrder_PaymentType): AddressType {
    switch (paymentType) {
      case SalesOrder_PaymentType.PAYMENT_TYPE_SEVEN_ELEVEN:
      case SalesOrder_PaymentType.PAYMENT_TYPE_FAMILY_MART: {
        return AddressType.STORE_ADDRESS;
      }
      case SalesOrder_PaymentType.PAYMENT_TYPE_CASH_ON_DELIVERY:
      case SalesOrder_PaymentType.PAYMENT_TYPE_CREDIT_CARD_CTBC:
      case SalesOrder_PaymentType.PAYMENT_TYPE_CREDIT_CARD:
      case SalesOrder_PaymentType.PAYMENT_TYPE_LINE_PAY:
      case SalesOrder_PaymentType.PAYMENT_TYPE_APPLE_PAY: {
        return AddressType.ADDRESS;
      }
      case SalesOrder_PaymentType.PAYMENT_TYPE_OVERSEA:
      case SalesOrder_PaymentType.PAYMENT_TYPE_OVERSEA_CTBC: {
        return AddressType.OVERSEA_ADDRESS;
      }
      default: {
        return AddressType.ADDRESS;
      }
    }
  }

  static payTypeDisplay(paymentType: SalesOrder_PaymentType): string {
    switch (paymentType) {
      case SalesOrder_PaymentType.PAYMENT_TYPE_SEVEN_ELEVEN: {
        return $localize`7-11 取貨付款`;
      }
      case SalesOrder_PaymentType.PAYMENT_TYPE_FAMILY_MART: {
        return $localize`全家 取貨付款`;
      }
      case SalesOrder_PaymentType.PAYMENT_TYPE_LINE_PAY: {
        return $localize`LINE Pay`;
      }
      case SalesOrder_PaymentType.PAYMENT_TYPE_CASH_ON_DELIVERY: {
        return $localize`宅配 貨到付款`;
      }
      case SalesOrder_PaymentType.PAYMENT_TYPE_APPLE_PAY: {
        return $localize`Apple Pay`;
      }
      case SalesOrder_PaymentType.PAYMENT_TYPE_CREDIT_CARD_CTBC:
      case SalesOrder_PaymentType.PAYMENT_TYPE_CREDIT_CARD: {
        return $localize`信用卡付款`;
      }
      case SalesOrder_PaymentType.PAYMENT_TYPE_OVERSEA:
      case SalesOrder_PaymentType.PAYMENT_TYPE_OVERSEA_CTBC: {
        return $localize`海外配送`;
      }
      default: {
        return '';
      }
    }
  }

  static startLinePay(router: Router, orderNo: string, linePayUrl: string): Promise<boolean> {
    return router.navigate([RouteHelper.thirdPartyPayment(orderNo)], {
      queryParams: { [Payments.LINE_PAY_PARAMETER]: linePayUrl },
    });
  }

  static startCreditCardPay(router: Router, orderNo: string, meta: string): Promise<boolean> {
    return router.navigate([RouteHelper.thirdPartyPayment(orderNo)], {
      queryParams: { [Payments.CREDIT_CARD_PARAMETER]: meta },
      replaceUrl: true,
    });
  }
}
